import countries from 'i18n-iso-countries'

const RulesMixin = {
  data: () => ({
    rules: {
      allowedIsoCountries: v => {
        const allowed = countries.getAlpha2Codes()
        return Object.keys(allowed).includes(v) || !v 
      }
    }
  })
}

export default RulesMixin